import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { ECommerceService } from "../services/e-commerce.service";
import { map } from "rxjs/operators";
import { SessionStorageService } from "../shared/services/session-storage.service";

export const routerGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  const eCommerceService = inject(ECommerceService);

  console.log('CanActivate Guard');
  let classificationIdentifier = sessionStorage.getItem('classificationIdentifier');
  let classificationName = sessionStorage.getItem('classificationName');

  let shopWindowRoute = sessionStorage.getItem('shopWindowRoute');
  let urlParameterClassification = route.paramMap.get('classificationIdentifier');

  if (!classificationIdentifier && !classificationName || classificationIdentifier && urlParameterClassification && classificationIdentifier !== urlParameterClassification) {
    return new Observable<boolean>((observer) => {
      eCommerceService.routerConfigByProductClassification(urlParameterClassification).subscribe((result) => {
        if (result && result.canActivate) {
          sessionStorage.setItem('classificationIdentifier', result.classificationIdentifier);
          sessionStorage.setItem('classificationName', result.classificationName);
          sessionStorage.setItem('shopWindowRoute', result.route);
          if (validateShopWindowRoute(result.route, state.url)) {
            observer.next(true);
          } else {
            observer.next(false);
            router.navigateByUrl('/404');
          }
        } else {
          observer.next(false);
          router.navigateByUrl('/404');
        }
      }, (error) => {
        console.error(error);
        router.navigate(['/404']);
      });
    }).pipe(map(result => result));
  } else {
    if (validateShopWindowRoute(shopWindowRoute, state.url)) {
      return true;
    } else {
      router.navigateByUrl('/404');
      return false;
    }
  }
};

function validateShopWindowRoute(route: string, url: string): boolean {
  let canActivate = true;
  let arrayUrl = url.split('?');
  url = arrayUrl && arrayUrl.length ? arrayUrl[0] : url;

  if (route === 'upgrade' && url.indexOf('meu-plano') >= 0) {
    return true;
  }

  if (route && route !== "") {
    if ((url.indexOf('meu-plano') >= 0 && route !== 'meu-plano') ||
      (url.indexOf('meu-pacote') >= 0 && route !== 'meu-pacote')) {
      canActivate = false;
    }
  } else {
    canActivate = false;
  }
  return canActivate;
}
